document.addEventListener('DOMContentLoaded', () => {
  const autoplayVideos = document.querySelectorAll(
    '[data-liya-autoplay-video="true"], .liya-product-video'
  );
  const pendingVideos = new Set();

  autoplayVideos.forEach((video) => {
    video.muted = true;
    pendingVideos.add(video);

    const tryPlay = () => {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.then(
          () => pendingVideos.delete(video),
          () => {
            // Autoplay blocked; retry once the video has buffered more data.
            video.addEventListener(
              'canplaythrough',
              () => video.play().then(() => pendingVideos.delete(video)).catch(() => {}),
              { once: true }
            );
          }
        );
      }
    };

    if (video.readyState >= 2) {
      tryPlay();
    } else {
      video.addEventListener('loadeddata', tryPlay, { once: true });
    }

    document.addEventListener(
      'visibilitychange',
      () => {
        if (document.visibilityState === 'visible' && video.paused) {
          tryPlay();
        }
      },
      { passive: true }
    );
  });

  // Some browsers (e.g. iOS Low Power Mode) block autoplay outright, even
  // when muted, until the user has interacted with the page at all. Once
  // that happens, immediately start any videos still waiting to play.
  if (pendingVideos.size > 0) {
    const playOnFirstInteraction = () => {
      pendingVideos.forEach((video) => {
        video.play().then(() => pendingVideos.delete(video)).catch(() => {});
      });
      if (pendingVideos.size === 0) {
        ['touchstart', 'click', 'scroll', 'keydown'].forEach((eventName) => {
          document.removeEventListener(eventName, playOnFirstInteraction);
        });
      }
    };

    ['touchstart', 'click', 'scroll', 'keydown'].forEach((eventName) => {
      document.addEventListener(eventName, playOnFirstInteraction, { passive: true });
    });
  }

  const scrubVideos = document.querySelectorAll('[data-scroll-scrub="true"]');

  scrubVideos.forEach((video) => {
    const section = video.closest('.liya-hero');
    if (!section) return;

    const maxProgressPercent = parseFloat(video.dataset.scrubMaxProgress) || 100;
    const maxProgress = Math.min(1, Math.max(0.1, maxProgressPercent / 100));

    let ready = false;

    const update = () => {
      if (!ready || !video.duration) return;
      const rect = section.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const total = rect.height + viewportHeight;
      const scrolled = viewportHeight - rect.top;
      const progress = Math.min(1, Math.max(0, scrolled / total));
      video.currentTime = progress * maxProgress * video.duration;
    };

    video.addEventListener('loadedmetadata', () => {
      video.pause();
      ready = true;
      update();
    });

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  });
});
